import '../style/drawer-By2xJK2s.css'
import { defineComponent as S, ref as z, useModel as A, reactive as I, computed as n, watch as p, openBlock as l, createBlock as m, mergeProps as u, unref as f, isRef as L, withCtx as P, createElementVNode as v, normalizeClass as T, normalizeStyle as U, withModifiers as M, renderSlot as b, createElementBlock as D, createVNode as R, createCommentVNode as w } from "vue";
import { pxlize as y } from "x-utils";
import j from "./spinner.js";
import q from "./internalComponents/CloseIcon.js";
import { INPUT_EVENT as F, UPDATE_MODEL_VALUE as h, CLOSE_EVENT as g } from "./constant/events.js";
import G from "./internalComponents/Overlay.js";
import { useAnimateClick as H } from "./hooks/useAnimateClick.js";
const J = {
  key: 0,
  class: "loading"
}, ee = /* @__PURE__ */ S({
  name: "e-drawer",
  inheritAttrs: !1,
  __name: "drawer",
  props: {
    modelValue: { type: Boolean },
    direction: { default: "ltr" },
    closeIcon: { type: [Boolean, String], default: !0 },
    persistent: { type: Boolean },
    theme: { default: "light" },
    inset: {},
    padding: {},
    loading: { type: Boolean },
    overflow: { type: Boolean },
    width: { default: "30%" },
    height: { default: "30%" },
    overlayOptions: {},
    disableOverlay: { type: Boolean }
  },
  emits: [F, h, g],
  setup(k, { emit: C }) {
    const t = k, a = C, _ = z(), r = A(t, "modelValue", { local: !0 }), { animate: s, animateClick: E } = H(), d = I({
      reversed: !1
    }), B = n(() => [
      {
        "e-drawer--animated": s.value,
        "e-drawer--loading": s.value,
        "e-drawer--overflow": t.overflow,
        "e-drawer--has-close-icon": t.closeIcon
      },
      `e-drawer--${t.theme}`
    ]), V = n(() => {
      const e = {};
      return t.padding && (e.padding = t.padding), t.direction === "ltr" || t.direction === "rtl" ? e.width = y(t.width) : e.height = y(t.height), e;
    }), $ = n(() => t.inset ? {
      inset: t.inset
    } : {}), N = n(() => `e-${t.direction}-transition`), O = (e) => {
      e && e.stopPropagation(), t.persistent ? E() : c();
    }, c = () => {
      a(h, !1), a(g);
    };
    return p(r, (e) => {
      a("input", e);
    }), p(() => t.direction, (e) => {
      d.reversed = e === "rtl" || e === "btt";
    }, { immediate: !0 }), (e, o) => (l(), m(G, u({
      open: f(r),
      "onUpdate:open": o[1] || (o[1] = (i) => L(r) ? r.value = i : null),
      transition: N.value,
      "overlay-click": O
    }, e.overlayOptions, { variant: "drawer" }), {
      default: P(({ zIndex: i }) => [
        v("div", u({
          class: ["e-drawer-wrapper", { reverse: d.reversed }],
          "data-overlay": "true",
          style: { ...$.value, zIndex: i }
        }, e.$attrs), [
          v("div", {
            ref_key: "content",
            ref: _,
            class: T(["e-drawer e-scroller", B.value]),
            style: U(V.value),
            onClick: o[0] || (o[0] = M(() => {
            }, ["stop"]))
          }, [
            b(e.$slots, "default"),
            e.loading ? (l(), D("div", J, [
              R(f(j), {
                size: 40,
                "color-scheme": "primary",
                "stroke-width": 3
              })
            ])) : w("", !0),
            e.closeIcon ? (l(), m(q, {
              key: 1,
              class: "e-drawer-close",
              onClick: c
            })) : w("", !0)
          ], 6)
        ], 16)
      ]),
      _: 3
    }, 16, ["open", "transition"]));
  }
});
export {
  ee as default
};
//# sourceMappingURL=drawer.js.map
